import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import Box from '../../atoms/Box';
import { clearGoogleProfile } from '../../../apis/SpreadsheetReportConfigs';

const scope =
  'frontend.components.SpreadsheetReportConfigs.Form.SpreadsheetForm';

const propTypes = {
  projectId: PropTypes.string,
  onGoogleLogin: PropTypes.func,
};

const GoogleAuthForm = ({ projectId, onGoogleLogin }) => {
  useEffect(() => {
    setTimeout(() => {
      clearGoogleProfile(projectId);
    }, 500);
  }, []);

  return (
    <Box>
      <Box.Header>
        <Box.Title>
          {I18n.t(`${scope}.fileSelectionSection.sectionTitle`)}
        </Box.Title>
      </Box.Header>
      <Box.Body>
        <div style={{ textAlign: 'left', padding: '20px' }}>
          <div
            style={{
              marginBottom: '20px',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.5',
              whiteSpace: 'pre-wrap',
            }}
          >
            <span>{I18n.t(`${scope}.fileSelectionSection.description`)}</span>
          </div>
          <BS.Button
            bsStyle='primary'
            style={{ padding: '9px 12px' }}
            onClick={onGoogleLogin}
          >
            <i
              className='fa fa-file-excel-o'
              style={{ marginRight: '8px' }}
            ></i>
            {I18n.t(`${scope}.action.selectFile`)}
          </BS.Button>
        </div>
      </Box.Body>
    </Box>
  );
};

GoogleAuthForm.propTypes = propTypes;

export default GoogleAuthForm;
